import { Uuid,success } from "@secretaa/http-contract";
import { z } from "zod";
/** Transport identity only. Worker resolves canonical AiRun/principal/funding before any model action. */
export const VERSION="1.2.0";
export const PATH="/internal/v1/ai/preparations/wakeup";
export const Command=z.object({workspaceId:Uuid,subjectId:Uuid,runId:Uuid,dispatchGeneration:z.number().int().min(1).max(5).optional()}).strict();
export type Command=z.infer<typeof Command>;

/** ACK after terminal state and accounting: root requires durable parent closure; a child is locally fenced and leaves its shared parent to the root. Never business completion. */
export const Result=z.object({runId:Uuid,state:z.enum(["SUCCEEDED","FAILED","INTERRUPTED"]),cleanup:z.enum(["CLOSED","CHILD_FENCED"])}).strict();
export type Result=z.infer<typeof Result>;
export const Response=success(Result);
